import { Component, EventEmitter, inject, input, Output } from '@angular/core';
import { ThemeService } from '../services/theme';
import { ResponsiveService } from '../services/responsive';
import { v3LayoutFlags } from '../services/v3-layout';
import { TimeAgo } from '../time-ago/time-ago';

// Shared header row for the V3 main-page overview cards (Scores/News/Competitor/Analysts/
// Earnings) — see CLAUDE.md. Renders the same 4-way Zero-desktop/Finnet-desktop/Finnet-
// mobile/Zero-mobile branch every card used to hand-copy.
@Component({
  selector: 'app-v3-overview-card-header',
  imports: [TimeAgo],
  standalone: true,
  templateUrl: './v3-overview-card-header.html',
  styleUrl: './v3-overview-card-header.scss',
})
export class V3OverviewCardHeader {
  private readonly themeService = inject(ThemeService);
  private readonly responsiveService = inject(ResponsiveService);

  readonly icon = input.required<string>();
  readonly title = input.required<string>();
  readonly updatedAt = input<Date | null>(null);
  readonly actionLabel = input.required<string>();
  // The one documented exception (V3NewsOverview's Zero-desktop header isn't itself a click
  // target, only its action button is) — every other branch/card is always fully clickable.
  readonly zeroDesktopClickable = input(true);

  @Output() navigate = new EventEmitter<void>();

  private readonly layout = v3LayoutFlags(this.themeService, this.responsiveService);
  readonly isZeroDesktop = this.layout.isZeroDesktop;
  readonly isFinnetDesktop = this.layout.isFinnetDesktop;
  readonly isFinnet = this.layout.isFinnet;

  onHeaderClick() {
    this.navigate.emit();
  }

  onDesktopHeaderKeydownSpace(event: Event) {
    if (!this.zeroDesktopClickable()) return;
    event.preventDefault();
    this.onHeaderClick();
  }
}
